import React from 'react';
import { ICollection, IContent } from 'types';

interface Props {
  collection: ICollection;
}

function SingleBannerCollection({ collection }: Props) {
  const { contents } = collection;
  const data = contents?.[0] as IContent | undefined;

  if (!data) return null;

  return (
    <div css={{ padding: '0 16px' }}>
      <img src={data.thumbnailUrl} alt="" css={{ width: '100%' }} />
    </div>
  );
}

export default SingleBannerCollection;
